import axios from "axios";

export default class RegionsService {
    static getRegions(){
        return axios.get(`api/region/get`)
    }
}